import React from 'react';
import { useTranslations } from '../../locales/useTranslations';
import FadeInAnimation from '../Common/FadeInAnimation';
import { BiDownload, BiCodeAlt, BiPlug, BiCheckCircle } from 'react-icons/bi';

const WooCommerceSchnittstelleHowItWorks = () => {
    const { t } = useTranslations();

    const steps = [
        {
            number: '01',
            icon: BiDownload,
            title: t('woocommerceSchnittstelle_howitworks_step1_title'),
            description: t('woocommerceSchnittstelle_howitworks_step1_desc'),
        },
        {
            number: '02',
            icon: BiCodeAlt,
            title: t('woocommerceSchnittstelle_howitworks_step2_title'),
            description: t('woocommerceSchnittstelle_howitworks_step2_desc'),
        },
        {
            number: '03',
            icon: BiPlug,
            title: t('woocommerceSchnittstelle_howitworks_step3_title'),
            description: t('woocommerceSchnittstelle_howitworks_step3_desc'),
        },
        {
            number: '04',
            icon: BiCheckCircle,
            title: t('woocommerceSchnittstelle_howitworks_step4_title'),
            description: t('woocommerceSchnittstelle_howitworks_step4_desc'),
        }
    ];

    return (
        <section className="wc-howitworks pt-100 pb-100">
            <div className="container">
                <div className="row mb-5">
                    <div className="col-12 text-center">
                        <FadeInAnimation direction="up" delay={50}>
                            <span className="wc-section-badge">
                                {t('woocommerceSchnittstelle_howitworks_badge')}
                            </span>
                            <h2 className="wc-section-title">
                                {t('woocommerceSchnittstelle_howitworks_title')}
                            </h2>
                        </FadeInAnimation>
                    </div>
                </div>

                <div className="row">
                    {steps.map((step, index) => {
                        const Icon = step.icon;
                        return (
                            <div key={index} className="col-lg-3 col-md-6 mb-4 d-flex flex-column">
                                <FadeInAnimation direction="up" delay={100 + (index * 100)} style={{ display: 'flex', flexDirection: 'column', flex: '1', height: '100%' }}>
                                    <div className="wc-howitworks__step">
                                        <div className="wc-howitworks__step-number">
                                            <span>{step.number}</span>
                                        </div>

                                        <div className="wc-howitworks__step-card">
                                            <div className="wc-howitworks__step-icon">
                                                <Icon />
                                            </div>
                                            <h3 className="wc-howitworks__step-title">
                                                {step.title}
                                            </h3>
                                            <p className="wc-howitworks__step-desc">
                                                {step.description}
                                            </p>
                                        </div>
                                    </div>
                                </FadeInAnimation>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default WooCommerceSchnittstelleHowItWorks;
